export const PREFETCH_PRICES_DELAY = 2000;
